import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './styles/mobile.css';
import axios from 'axios';

Vue.config.productionTip = false;
Vue.use(ElementUI);

axios.defaults.baseURL = '/api';
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
axios.interceptors.response.use((res) => {
  if (res.data && res.data.code === 401) {
    ['admin_token', 'admin_id', 'admin_username', 'admin_role_id', 'admin_role_name', 'admin_permissions'].forEach((k) => localStorage.removeItem(k));
    router.push('/login');
  }
  return res.data;
});

Vue.prototype.$http = axios;

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app');
